var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0.9970891,
    x2: 0.5,
    y2: 0.007767216,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 1.46098876,
    x2: 0.5,
    y2: -0.451596826,
    id: "gradient_2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 6.58140564,
    x2: 0.5,
    y2: -1.40029287,
    id: "gradient_3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/social-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.76649 0L11.2335 0C13.8617 0 16 2.13823 16 4.76649L16 11.2335C16 13.8618 13.8618 16 11.2335 16L4.76649 16C2.13823 16 0 13.8618 0 11.2335L0 4.76649C0 2.13823 2.13823 0 4.76649 0ZM11.2335 14.3904C12.977 14.3904 14.3904 12.977 14.3904 11.2335L14.3904 4.76649C14.3904 3.02297 12.977 1.6096 11.2335 1.6096L4.76649 1.6096C3.023 1.6096 1.6096 3.02297 1.6096 4.76649L1.6096 11.2335C1.6096 12.977 3.023 14.3904 4.76649 14.3904L11.2335 14.3904Z",
    id: "Shape",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.99999C0 1.7944 1.7944 0 4 0C6.2056 0 8 1.79437 8 3.99999C8 6.2056 6.2056 8 4 8C1.7944 8 0 6.20557 0 3.99999ZM1.55586 4.00001C1.55586 5.34989 2.65013 6.44417 4 6.44417C5.34985 6.44417 6.44414 5.34986 6.44414 4.00001C6.44414 2.65014 5.34987 1.55586 4 1.55586C2.65015 1.55586 1.55586 2.65014 1.55586 4.00001Z",
    transform: "translate(4 4)",
    id: "Shape",
    fill: "url(#gradient_2)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z",
    transform: "translate(11.33333 2.666667)",
    id: "Oval",
    fill: "url(#gradient_3)",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.3f623c33a835f36088984b5ad9ec0198.svg";
export { ForwardRef as ReactComponent };